import access from './access.html';
import bathroomEquipment from './bathroomEquipment.html';
import construction from './construction.html';
import constructionYear from './constructionYear.html';
import electricity from './electricity.html';
import equipment from './equipment.html';
import familyHouse_LandArea from './family_house/landArea.html';
import floor from './floor.html';
import floorArea from './floorArea.html';
import gas from './gas.html';
import kitchenEquipment from './kitchenEquipment.html';
import land_electricity from './land/electricity.html';
import land_gas from './land/gas.html';
import land_parcelNumber from './land/parcelNumbers.html';
import land_sewerage from './land/sewerage.html';
import land_water from './land/water.html';
import landArea from './landArea.html';
import landType from './landType.html';
import location from './location.html';
import outerBuildings from './outerBuildings.html';
import overgroundFloors from './overgroundFloors.html';
import ownership from './ownership.html';
import permanentVegetation from './permanentVegetation.html';
import reconstructions from './reconstructions.html';
import roomLayout from './roomLayout.html';
import sewerage from './sewerage.html';
import state from './state.html';
import toiletEquipment from './toiletEquipment.html';
import undergroundFloors from './undergroundFloors.html';
import unitNumber from './unitNumber.html';
import water from './water.html';

export default {
   /* tslint:disable-next-line */
   apartment_house: {},
   commercial: {},
   common: {
      access,
      bathroomEquipment,
      construction,
      constructionYear,
      electricity,
      equipment,
      floor,
      floorArea,
      gas,
      kitchenEquipment,
      landArea,
      landType,
      location,
      outerBuildings,
      overgroundFloors,
      ownership,
      permanentVegetation,
      reconstructions,
      roomLayout,
      sewerage,
      state,
      toiletEquipment,
      undergroundFloors,
      unitNumber,
      water,
   },
   flat: {},
   /* tslint:disable-next-line */
   family_house: {
      landArea: familyHouse_LandArea,
   },
   land: {
      electricity: land_electricity,
      gas: land_gas,
      parcelNumbers: land_parcelNumber,
      sewerage: land_sewerage,
      water: land_water,
   },
   garage: {},
   recreational: {},
} as { [estateType: string]: { [parameterName: string]: string } };
